import {
  Modal,
  ModalOverlay,
  ModalContent,
  Flex,
  Box,
  Icon,
  Text,
  ModalHeader,
  ModalCloseButton,
  Stack
} from '@chakra-ui/react';
import LensCard from '@components/lens/lens-card.component';
import LensIcon from '@assets/icons/sf-icons/lens.icon';

export default function CreateLensSuccessModal({ isOpen, onClose, lens = {} }) {
  return (
    <Modal
      variant='classic'
      isOpen={isOpen}
      onClose={onClose}
      size='2xl'
      border='reskin'
      isCentered
    >
      <ModalOverlay />

      <ModalContent mx={{ base: 4, xl: 'unset' }}>
        <ModalHeader
          bgColor='brandPrimary.onContainer'
          color='brandPrimary.onPrimary'
        >
          <Flex
            justifyContent='flex-start'
            alignItems='center'
            gap={2}
          >
            <Icon as={LensIcon} />
            <Text>Lens Created</Text>
          </Flex>
        </ModalHeader>
        <ModalCloseButton color='white' />
        <Stack
          p={11}
          gap={8}
          direction={{ base: 'column', xl: 'row' }}
          alignItems='center'
        >
          <Box flex={3}>
            <LensCard
              lens={lens}
              enableNavigation={false}
            />
          </Box>
          <Box flex={4}>
            <Text>Your lens has been created.</Text>
            <Text>
              Your Lens is now <b color='brandPrimary.onContainer'>active</b>. FORA is busy
              analyzing your data and creating an update based on your criteria. You will receive
              your first Lens update within 24 hours.
            </Text>
          </Box>
        </Stack>
      </ModalContent>
    </Modal>
  );
}
